module.exports = __webpack_public_path__ + "img/pr-15.8cdf046c.png";